import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

// Пошук і фільтри в адмінці зберігаються в адресному рядку, але списки їх
// не читали — тому нічого не фільтрувалось. Цей хук дає списку вже готові
// значення, а для невеликих довідників (програми, відгуки, команда) —
// одразу відфільтрований масив.

const getText = (value) => {
  if (value === null || value === undefined) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'number') return String(value);
  if (typeof value === 'object') {
    return [value.ua, value.en].filter(Boolean).join(' ');
  }
  return '';
};

// Значення поля за шляхом «author.name» або через функцію.
const readField = (item, field) => {
  if (typeof field === 'function') return getText(field(item));

  return getText(
    String(field)
      .split('.')
      .reduce((value, key) => (value === null || value === undefined ? value : value[key]), item)
  );
};

export function matchesSearch(item, query, fields) {
  const normalized = String(query || '').trim().toLowerCase();

  if (!normalized) return true;

  return fields.some((field) => readField(item, field).toLowerCase().includes(normalized));
}

// Статус у фільтрі — «active» / «inactive»; у даних це прапорець isActive.
export function matchesActiveStatus(item, statusParam, flag = 'isActive') {
  if (!statusParam) return true;

  const wanted = String(statusParam)
    .split(',')
    .map((value) => value.trim())
    .filter(Boolean);

  if (wanted.length === 0) return true;

  const isActive = item?.[flag] !== false;

  return wanted.includes(isActive ? 'active' : 'inactive');
}

export function useListFilters() {
  const [searchParams] = useSearchParams();

  return useMemo(
    () => ({
      query: searchParams.get('q') || '',
      params: Object.fromEntries(searchParams.entries()),
      get: (key) => searchParams.get(key) || '',
    }),
    [searchParams]
  );
}

// Фільтрація довідника цілком на клієнті: дані невеликі, зате працює
// миттєво й не вимагає окремих запитів на сервер.
export function useFilteredList(items, { query, fields = [], extraFilters = [] }) {
  return useMemo(() => {
    const list = Array.isArray(items) ? items : [];

    return list.filter(
      (item) =>
        matchesSearch(item, query, fields) &&
        extraFilters.every((check) => check(item))
    );
  }, [items, query, fields, extraFilters]);
}
